module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/landprocurement/joint-venture/jv-exceptence/jv-exceptence-grid/jv-exceptence-grid.component.css
// module id = ./src/app/landprocurement/joint-venture/jv-exceptence/jv-exceptence-grid/jv-exceptence-grid.component.css
// module chunks = main